import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'day8-ui';
// import { updateSearch } from '../helpers/querystring';
import history from '../history';
import { onFilterSelect } from '../helpers/filter';
import { useDispatch } from 'react-redux';
import { filterBookingOptions } from '../actions/bookingOptions';
import { FILTERS } from '../constants';

const CabinsCrewNotifications = ({
  total, maxCapacity, availability, soloTypesCount, cabinTypesCount
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    // dismiss toasts on unmount
    return () => toast.dismiss();
  });
  const maxSoloAvailabilityReached = availability && availability.solo !== null && availability.solo < 1;
  const maxCabinAvailabilityReached = availability && availability.cabin !== null && availability.cabin < 1;
  // if availability is null or 0 and nothing is selected that means is not available by default (sold out) so shouldn't show notification
  let solosSoldOut = false;
  let cabinsSoldOut = false;
  const totalSelectedSolos = soloTypesCount;
  const totalSelectedCabins = cabinTypesCount;
  if (maxSoloAvailabilityReached && totalSelectedSolos < 1) {
    solosSoldOut = true;
  }
  if (maxCabinAvailabilityReached && totalSelectedCabins < 1) {
    cabinsSoldOut = true;
  }
  useEffect(() => {
    if ((total === maxCapacity)) {
      toast.info(`Want to book more cabins?`, {
        id: "max-capacity-reached",
        duration: 5000,
        action: {
          label: 'Browse yachts',
          onClick: () => {
            onFilterSelect(history.location, dispatch, filterBookingOptions, FILTERS.CABIN_BOOKING_TYPE, null);
            // In case we wanna push to custom yachts
            // history.push({
            //   pathname: `/browse/${isYachtsAndFriends ? 'yachtsandfriends/flotilla/crew' : 'yachts'}`,
            //   search: updateSearch(history.location, { soloType: null, cabinType: null })
            // });
          }
        }
      });

    }
    else if (!cabinsSoldOut && maxCabinAvailabilityReached) {
      toast.info(`Maximum cabins selected.`, {
        id: "max-cabin-reached",
        duration: 5000
      });
    }
    else if (!solosSoldOut && maxSoloAvailabilityReached) {
      toast.info(`Maximum shared spots selected.`, {
        id: "max-solo-reached",
        duration: 5000
      });
    }
    return () => toast.dismiss();
  }, [total, maxCapacity, totalSelectedCabins, maxSoloAvailabilityReached, maxCabinAvailabilityReached]);
  return null;
};
CabinsCrewNotifications.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  total: PropTypes.number.isRequired,
  maxCapacity: PropTypes.number.isRequired,
  availability: PropTypes.object.isRequired,
  isYachtsAndFriends: PropTypes.bool,
  isBviCnct: PropTypes.bool
};

export default CabinsCrewNotifications;
